/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { AppContext } from "../../../context";
import { post } from "../Common/util";
import * as types from "../../../Actions/actionTypes";
import { useLocation } from "react-router-dom";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles(() => ({
  checkoutContainer: {
    "& #px-modal-backdrop": {
      width: "100% !important",
    },
  },
}));

const SwedbankPay = React.memo((props) => {
  const { classes } = useStyles();
  const rdxDispatch = useDispatch();
  const { state } = useContext(AppContext);
  const { config, culture, saleId, currency, userManager } = state;
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  console.log("SwedbankPay (re)render ------------------------ ");

  const startOnePagePaymentProcessUrl = `${config.apiUri}/api/swedbankpay/onepage/${saleId}?locale=${culture}&currency=${currency}`;

  // Get Access Token from user
  let accessToken = null;
  userManager.getUser().then((user) => {
    if (user && user.access_token) {
      accessToken = user.access_token;
    }
  });

  // On first render - Add dependencies
  useEffect(() => {
    setLoaded(true);
    return () => {};
  }, []);

  const redirectPayment = useMemo(() => {
    const queryStrings = location.search;
    const getSwedbankQuery = queryStrings.split("swedbankpay-checkout-url=");
    if (getSwedbankQuery.length > 0) {
      return getSwedbankQuery?.[1];
    }
    return null;
  }, [location]);

  //On first render - Call external api
  useEffect(() => {
    console.log("-- SwedbankPay - Call API to start payment process");
    if (!redirectPayment && loaded === true) {
      const startPaymentProcess = async () => {
        const response = await post(accessToken, startOnePagePaymentProcessUrl);

        if (response.status !== 200) {
          console.log("-- SwedbankPay ERROR, status:", response.status);
          rdxDispatch({
            type: types.ERROR,
            payload: "Could_Not_Start_OnePage_Payment_Error",
          });

          //
          //todo: dölj onepage vid error?
          //
        } else {
          console.log(response);
          let json = await response.json();
          console.log(json);
          var script = document.createElement("script");
          var operation = json.operations["view-checkout"];

          script.setAttribute("src", operation.href);
          script.onload = function () {
            // When the 'view-checkout' script is loaded, we can initialize the
            // Payment Menu inside 'checkout-container'.
            window.payex.hostedView
              .checkout({
                container: {
                  checkout: "checkout-container-div",
                },
                culture: culture,
              })
              .open();
          };
        }
        var head = document.getElementsByTagName("head")[0];
        head.appendChild(script);
      };
      setLoaded(true);
      startPaymentProcess();
    }
  }, [loaded]);

  useEffect(() => {
    console.log("-- SwedbankPay - Checking payment");
    if (redirectPayment && loaded === true) {
      var script = document.createElement("script");
      script.setAttribute("src", redirectPayment);
      script.onload = function () {
        window.payex.hostedView
          .checkout({
            container: {
              checkout: "checkout-container-div",
            },
            culture: culture,
          })
          .open();
      };
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(script);
    }
  }, [loaded, redirectPayment]);

  return (
    <>
      <div
        id="checkout-container-div"
        className={classes.checkoutContainer}
      ></div>
    </>
  );
});

export default SwedbankPay;
